module.exports = __webpack_public_path__ + "static/media/img9.4d2b4c05.webp";